module.exports = __webpack_public_path__ + "media/images/city/084-great-buddha-of-thailand-c0248a6a99042e05520b0769a1b8a797.svg";